import { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { SERVICE_TYPES } from '../constants';

export const UrgentCaseModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    clientId: '',
    serviceType: SERVICE_TYPES.URGENT_COUNSELING,
    urgencyReason: '',
    isUrgent: true
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSubmit(formData);
    } catch (error) {
      console.error('Error submitting urgent case:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            <h3 className="text-lg font-medium">Register Urgent Case</h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Student ID/Registration Number
            </label>
            <input
              type="text"
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-uzima-maroon-400 focus:ring-uzima-maroon-400"
              value={formData.clientId}
              onChange={(e) => setFormData(prev => ({
                ...prev,
                clientId: e.target.value
              }))}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Reason for Urgency
            </label>
            <textarea
              required
              rows={4}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-uzima-maroon-400 focus:ring-uzima-maroon-400"
              value={formData.urgencyReason}
              onChange={(e) => setFormData(prev => ({
                ...prev,
                urgencyReason: e.target.value
              }))}
            />
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <div className="flex">
              <AlertTriangle className="h-5 w-5 text-yellow-400" />
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  This will create an urgent appointment and may require rescheduling other appointments.
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 border rounded-md hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:bg-red-300 flex items-center"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                  Processing...
                </>
              ) : (
                'Register Urgent Case'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};